import React from 'react';
import { Alert, Button, Spin } from 'antd';
import { useOneButtonStore } from '../../../../../store/oneButtonStore';
import '../oneButton-css/OpportunityInitializationOverlay.css';

interface OpportunityInitializationOverlayProps {
    theme: 'dark' | 'light';
    visible: boolean;
    onSwitchToViewer?: () => void;
    onRetry?: () => void;
}

export const OpportunityInitializationOverlay: React.FC<OpportunityInitializationOverlayProps> = ({
    theme,
    visible,
    onSwitchToViewer,
    onRetry,
}) => {
    const phase = useOneButtonStore((s) => s.opportunityInitializationPhase);
    const error = useOneButtonStore((s) => s.opportunityInitializationError);

    if (!visible) return null;

    return (
        <div
            className={`obd-opportunity-init-overlay obd-theme-${theme}`}
            role="status"
            aria-live="polite"
            aria-busy={!error}
            aria-label="Loading opportunity information"
        >
            <div className="obd-opportunity-init-overlay__panel obd-card">
                {error ? (
                    <>
                        <Alert
                            type="warning"
                            showIcon
                            message={error}
                            description="This Salesforce opportunity is not available in oneBUTTON. Open a valid opportunity or switch to the 3D viewer."
                        />
                        <div className="obd-opportunity-init-overlay__actions">
                            {onRetry ? (
                                <Button type="primary" onClick={onRetry}>
                                    Retry
                                </Button>
                            ) : null}
                            {onSwitchToViewer ? (
                                <Button type="default" onClick={onSwitchToViewer}>
                                    Switch to 3D Viewer
                                </Button>
                            ) : null}
                        </div>
                    </>
                ) : (
                    <>
                        <Spin size="large" />
                        <p className="obd-opportunity-init-overlay__title">
                            Loading opportunity information
                        </p>
                        <p className="obd-opportunity-init-overlay__phase">
                            {phase || 'Please wait…'}
                        </p>
                        {/* {onSwitchToViewer ? (
                            <Button
                                type="default"
                                size="small"
                                className="obd-opportunity-init-overlay__viewer-btn"
                                onClick={onSwitchToViewer}
                            >
                                Switch to 3D Viewer
                            </Button>
                        ) : null} */}
                    </>
                )}
            </div>
        </div>
    );
};
